import { useState } from "react";
import { toast } from "sonner";
import { Share2, Instagram, MessageCircle, MessageSquare, Link2 } from "lucide-react";
import { M } from "../lib/site";

const TEXT = "Eleganté Grand Opening — Friday 13 November, 9PM til late. Level 1/412 Little Collins St, Melbourne.";

const flyerFile = async () => {
  const blob = await (await fetch(M.flyer)).blob();
  return new File([blob], "elegante-grand-opening.jpg", { type: "image/jpeg" });
};

const Pill = ({ icon: Icon, label, testid, ...rest }) => {
  const Tag = rest.href ? "a" : "button";
  return (
    <Tag data-testid={testid} {...rest}
      className="btn-ghost inline-flex items-center justify-center gap-2 rounded-full px-4 py-3 text-[11px] font-medium uppercase tracking-[0.18em] text-[#F8F6F0]">
      <Icon size={14} /> {label}
    </Tag>
  );
};

export const ShareFlyer = () => {
  const [busy, setBusy] = useState(false);
  const url = window.location.origin;
  const msg = `${TEXT} ${url}`;

  // Native share sheet with the flyer image (Instagram Stories, WhatsApp, Messages on phones).
  const shareImage = async () => {
    setBusy(true);
    try {
      const file = await flyerFile();
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: msg });
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        a.download = file.name;
        a.click();
        toast.success("Flyer saved — post it to your Instagram story and tag @elegantemelbourne");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't share right now — try again.");
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(msg);
      toast.success("Link copied");
    } catch {
      toast.error("Couldn't copy the link");
    }
  };

  return (
    <div className="flex w-full flex-col items-center gap-3 sm:flex-row sm:justify-between" data-testid="share-flyer">
      <p className="eyebrow">Share the flyer</p>
      <div className="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto">
        <Pill icon={busy ? Share2 : Instagram} label={busy ? "Preparing…" : "Instagram"} testid="share-instagram-btn" onClick={shareImage} disabled={busy} />
        <Pill icon={MessageCircle} label="WhatsApp" testid="share-whatsapp-btn" href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer" />
        <Pill icon={MessageSquare} label="Text" testid="share-sms-btn" href={`sms:?&body=${encodeURIComponent(msg)}`} />
        <Pill icon={Link2} label="Copy link" testid="share-copy-btn" onClick={copy} />
      </div>
    </div>
  );
};
